//import { getLiquidaciones } from "../config/envConfig";
import React from 'react';
import backgroundImg from '../pages/assets/img/introLanding.jpg'
//import flkLogo from '../pages/assets/img/logoFarmalink.png';
import secureLogo from '../pages/assets/img/CNHS-3.0,0.png';
import farmaNews from '../pages/assets/img/noticias/farma-news.png';
import { getAlfresco } from '../config/envConfig';
/*import { HashLink } from 'react-router-hash-link';
import { HashRouter as Router, Link } from 'react-router-dom';*/
import createHistory from 'history/createBrowserHistory';
import { NavbarMain } from './NavbarMain';
import { HashRouter as Router } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

export default class PagNoticias extends React.Component{

    constructor(props) {
        super();
        let tamaño = props.noticia && props.noticia.length <= 20 ? props.noticia.length : 20;
        let array = [];
        if(props.noticia){
            for(let i = 0; i<tamaño;i++){
                array.push(props.noticia[i]);
            }
        }
        this.state = {
          return: array
        }
    }

    componentDidMount(){
        const history = createHistory();
        const previousHash = history.location.hash;
        document.getElementById("about").style.display = 'block';
        document.getElementById("map-farma").style.display = 'none';
        /*if(!this.state.return[0]){
            const urlContent = getAlfresco()+'/getNoticiasContent';
              var respuesta = [];
              fetch(urlContent, {
                  method: 'GET',
                  headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json'
                  }
              }).then(response => 
                response.json().then(data => {
                    if(data && data.estado && data.estado.codigo === "0" && data.contentList[0]){
                        let tamanio = data.contentList.length > 20 ? 20 : data.contentList.length;
                        for(var i = 0;i<tamanio;i++){
                            respuesta.push(data.contentList[i]); 
                        }
                    } 
                    this.setState({return: respuesta});
                })
            )
          }*/
        this.backListener = history.listen((location,action) => {
          if(action === 'POP' && location.hash !== previousHash){
            window.location.reload();
          }
        })
    }

    componentWillUnmount(){
        document.getElementById("map-farma").style.display = 'inline-block';
        this.backListener();
    }
    
    render(){
        function goToTopFunc(){
            document.querySelector('body').scrollTo(0,0);
        }
        return(
            <div>
                <header>
                    <NavbarMain home={false}/>
                </header>

                <main role="main">
                    <section id="faq" class="intro-section-subpage">
                        <div class="subpageFarma" style={{backgroundImage: `url(${backgroundImg})`}}></div>
                        <div class="intro-subpage">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="main-heading">
                                            <h4>NOVEDADES</h4>
                                            <h1>Últimas Noticias</h1>
                                        </div>
                                    </div>
                                    <div class="col-12 content">
                                        <div class="row justify-content-md-center">
                                            <div class="col col-lg-10">
                                                {this.state.return && this.state.return[0] ? this.state.return.map((el) => (
                                                    <a id={el.alfrescoId} class="list-public" href={el.absoluteURL} target="_blank" rel="noreferrer">
                                                        <div class="row">
                                                            <div class="col-sm-2 date">{el.inDate}</div>
                                                            <div class="col-sm-7 title">{el.title}</div>
                                                            <div class="col-sm-3 hidden-xs">
                                                                {el.codigoEntidad ? "": <img src={farmaNews} class="img-responsive" alt=""/>}
                                                            </div>
                                                        </div>
                                                    </a>
                                                )) : <p style={{textAlign: 'center'}}>No es posible recuperar la lista de noticias</p>}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                   
                    
                </main>
            </div>
        );
    }
}

/* <div id="back-top">
                        <button class="rounded">
                            <i class="fa fa-angle-up"></i>
                        </button>
                    </div>*/